import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '0.5rem 0.75rem',
    color: theme.palette.warningAccent
}));
const Message = styled(Typography)({
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem'
});
// More compact than MUI's `small`, to sit level with a line of body text.
const RetryButton = styled(Button)({
    minWidth: 0,
    padding: '0.0625rem 0.5rem',
    fontSize: '0.75rem',
    lineHeight: 1.5,
    '& .MuiButton-startIcon': {
        marginLeft: '-0.125rem',
        marginRight: '0.25rem',
        '& > *:nth-of-type(1)': { fontSize: '0.875rem' }
    }
});
/** An inline warning that a list's items failed to load, with a button to load them again. */
export const ListLoadError = ({ message, onRetry, className }) => (_jsxs(Root, { className: className, children: [_jsxs(Message, { variant: 'body2', children: [_jsx(WarningAmberRoundedIcon, { fontSize: 'small' }), message] }), _jsx(RetryButton, { variant: 'outlined', size: 'small', startIcon: _jsx(RefreshRoundedIcon, {}), onClick: onRetry, children: "Retry" })] }));
//# sourceMappingURL=list-load-error.js.map